"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaErrorNoDetailsToJSON = exports.RosettaErrorNoDetailsFromJSONTyped = exports.RosettaErrorNoDetailsFromJSON = void 0;
function RosettaErrorNoDetailsFromJSON(json) {
    return RosettaErrorNoDetailsFromJSONTyped(json, false);
}
exports.RosettaErrorNoDetailsFromJSON = RosettaErrorNoDetailsFromJSON;
function RosettaErrorNoDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': json['code'],
        'message': json['message'],
        'retriable': json['retriable'],
    };
}
exports.RosettaErrorNoDetailsFromJSONTyped = RosettaErrorNoDetailsFromJSONTyped;
function RosettaErrorNoDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'message': value.message,
        'retriable': value.retriable,
    };
}
exports.RosettaErrorNoDetailsToJSON = RosettaErrorNoDetailsToJSON;
//# sourceMappingURL=RosettaErrorNoDetails.js.map